"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react');


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _pins = require('shared/services/pins');







// Pin or Unpin from an inbox row. The row moves at once, except a Pin near
// the limit, which waits for the server (shared/services/pins); when the
// server rejects the change or never answers, the row stays or moves back
// and the inbox's notice for a failed row action says so. At the limit, the
// toast explains instead.
 const usePinBlobject = ({ showWarningBar, showPinLimit }) => _react.useCallback.call(void 0, 
  async (blobjectKey, pinned, previous) => {
    const error = await _actions2.default.setBlobjectPinned(blobjectKey, pinned, previous).then(() => null, (e) => _nullishCoalesce(e, () => ( 'failed')))
    if (!error) return true
    if (_pins.isPinLimitError.call(void 0, error)) showPinLimit(_pins.PIN_LIMIT_MESSAGE)
    else showWarningBar(pinned ? 'Failed to pin conversation' : 'Failed to unpin conversation')
    return false
  },
  [showWarningBar, showPinLimit],
); exports.usePinBlobject = usePinBlobject
